function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.5179mm",
    height: "4.2968mm",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M49 17c0,-3 -4,-8 -10,-11 -2,3 -3,7 -3,11 0,4 1,8 3,10 6,-2 10,-7 10,-10l0 0zm-9 -4c1,0 2,1 2,2 0,1 -1,2 -2,2 -1,0 -2,-1 -2,-2 0,-1 1,-2 2,-2zm-5 -8c-1,0 -3,0 -4,0 -2,-3 -9,-6 -11,-5 1,3 1,4 1,6 -3,1 -6,4 -10,6 -2,-2 -7,-5 -11,-4 0,4 2,8 3,9 -1,1 -3,5 -3,9 4,0 9,-2 11,-5 4,3 7,6 10,7 0,1 0,3 -1,5 2,1 9,-2 11,-4 1,0 3,0 4,-1 -2,-3 -3,-7 -3,-11 0,-5 1,-9 3,-12z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.911a55b35cf62b419fbeab0fff0ad31d.svg";
export { ForwardRef as ReactComponent };